import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { ReportApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  history_data: null
};

const ReportSlice = createSlice({
  name: 'Report',
  initialState,
  reducers: {
    setReportGrid(state, action) {
      state.list_data = action.payload;
    },
    setHistoryGrid(state, action) {
      state.history_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Report List
export const getReportsList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: ReportApi?.reportList,
      method: 'post',
      payload: data
    });
    {
      console.log('Report List res', res);
    }
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setReportGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setReportGrid(null)); // store in redux
      dispatch(setApiError(res?.error || 'Something went wrong'));
      console.error('❌ Report List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Report List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// History List
export const getHistoryReportList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${ReportApi?.reportHistoryList}/${data}`,
      method: 'get',
      payload: data
    });

    console.log('History List response', res);

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setHistoryGrid(res?.data ? res?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setHistoryGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Report List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Report List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setReportGrid, setHistoryGrid } = ReportSlice.actions;
export default ReportSlice.reducer;
